import _styled from "@emotion/styled/base";
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { Stack } from '../../../../../../../primitives/index.js';
export const SublineWrapper = /*#__PURE__*/_styled(Stack, process.env.NODE_ENV === "production" ? {
  target: "e1ykrcfn0"
} : {
  target: "e1ykrcfn0",
  label: "SublineWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "132a2g2",
  styles: "padding-left:32px"
} : {
  name: "132a2g2",
  styles: "padding-left:32px/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlN1YmxpbmVXcmFwcGVyLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUU0QyIsImZpbGUiOiJTdWJsaW5lV3JhcHBlci5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCB7IFN0YWNrIH0gZnJvbSAnLi4vLi4vLi4vLi4vLi4vLi4vLi4vcHJpbWl0aXZlcy9pbmRleC5qcyc7XG5leHBvcnQgY29uc3QgU3VibGluZVdyYXBwZXIgPSBzdHlsZWQoU3RhY2spIGBcbiAgcGFkZGluZy1sZWZ0OiAzMnB4O1xuYDtcbi8vIyBzb3VyY2VNYXBwaW5nVVJMPVN1YmxpbmVXcmFwcGVyLmpzLm1hcCJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});